import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag'
import { flowRight as compose } from 'lodash'
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import Link from '../../Link';
// Style
import {
  FormGroup,
  Col,
  FormControl,
  Container,
  Row,
  Form
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../../Common/Loader';
import { injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import GooglePolygonMap from '../../Common/GooglePolygonMap';

import s from './ManageLocation.css';
import bt from '../../../components/commonStyle.css';
class ManageLocationForm extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
  }
  static defaultProps = {
    loading: false
  };
  componentDidMount() {

  }
  handlePlaceChanged() {
    const place = this.autocomplete.getPlace();
    this.props.onPlaceLoaded(place);
  }
  renderFormControl = ({ input, label, type, meta: { touched, error }, className, note }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={s.formGroup}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className={bt.noPadding}>
            <label className={bt.labelText} >{label}</label>
            <FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} />
            {
              note && <p className={s.subtext}>{note}</p>
            }
            {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
          </Col>
        </Row>
      </FormGroup>
    );
  }
  renderTextAreaField = ({ input, label, type, meta: { touched, error }, children, labelClass, fieldClass, placeholder }) => {
    const { formatMessage } = this.props.intl;
    return (
      <Form.Group className={s.formGroup}>
        <label className={bt.labelText} >{label}</label>
        <Form.Control as="textarea" rows="3" {...input} placeholder={placeholder} type={type} className={fieldClass} />
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </Form.Group>
    )
  }
  render() {
    const { error, handleSubmit, submitting, loading, isEditForm, initialValues, updateLoading } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx(s.pagecontentWrapper, 'mapSection')}>
        <Container className={s.containerWith}>
          <div className={s.contentBox}>
            <h1 className={s.headerTitle}>{formatMessage(isEditForm ? messages.editLocation : messages.addLocation)}</h1>
            <div className={cx(s.blockcenter, s.passwordSection, 'bgBlackTwo')}>
              <Form className={s.fullWidth} onSubmit={handleSubmit(submit)} >
                {error && <strong>{error}</strong>}
                <Field
                  name="locationName"
                  type="text"
                  component={this.renderFormControl}
                  label={formatMessage(messages.nameOnly)}
                  className={bt.formControlInput}
                />
                {isEditForm &&
                  <div className={bt.space3}>
                    <label className={bt.labelText} >{formatMessage(messages.status)}</label>
                    <Field name="isActive" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                      <option value={true}>{formatMessage(messages.active)}</option>
                      <option value={false}>{formatMessage(messages.inactive)}</option>
                    </Field>
                  </div>
                }
                <Field
                  name="description"
                  type="text"
                  placeholder={formatMessage(messages.description)}
                  component={this.renderTextAreaField}
                  label={formatMessage(messages.description)}
                  labelClass={bt.labelText}
                  fieldClass={bt.formControlInput}
                />
                <div className={cx(s.relative, 'manageSearchLocation')}>
                  {isEditForm && initialValues?.path ? <GooglePolygonMap
                    formName={'ManageLocationForm'}
                    fieldName={'path'}
                    paths={initialValues?.path}
                    inputClass={cx(bt.formControlInput,'form-control')}
                    
                  /> :
                    <GooglePolygonMap
                      formName={'ManageLocationForm'}
                      fieldName={'path'}
                      inputClass={cx(bt.formControlInput,'form-control')}
                    />
                  }
                </div>
                <Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop4, 'textAlignLeftRTL', 'loadingBtnRTL', s.noPadding)}>
                  <Form.Group className={cx(bt.commonEditFormButtonContainer, s.noMargin)}>
                    <div className={s.displayInlineBlock}>
                      <Loader
                        type={"button"}
                        label={formatMessage(messages.submitButton)}
                        show={loading || updateLoading}
                        buttonType={'submit'}
                        className={cx(bt.btnPrimary)}
                        disabled={submitting || loading || updateLoading}
                        isSuffix={true}
                      />
                    </div>
                    <Link to={"/siteadmin/location"} className={bt.btnSecondary} >{formatMessage(messages.goBack)}</Link>
                  </Form.Group>
                </Col>
              </Form>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}
ManageLocationForm = reduxForm({
  form: 'ManageLocationForm',
  onSubmit: submit,
  validate
})(ManageLocationForm);

const mapState = (state) => ({
  loading: state.loader.AddLocation,
  updateLoading: state.loader.updateLocation
});
const mapDispatch = {};
export default injectIntl(compose(
  withStyles(s, bt),
  connect(mapState, mapDispatch)
)(ManageLocationForm));
